import { derived, get, writable } from "svelte/store";
import { shuffleVideos } from "@components/Video";
import { experience, response, viewport } from "@stores/global";
import getVideoSourceWithParams from "@utils/get-video-source";

// Matches Safari 15 on mobile, ipad and desktop
const SAFARI_15_REGEX = /15\.\d+\s+(mobile\/[a-z0-9]+\s)?safari/i;

export const dwellLoaded = writable(false);
const isSafari15 = writable(false);

dwellLoaded.subscribe((loaded) => {
  if (
    loaded &&
    typeof window !== "undefined" &&
    SAFARI_15_REGEX.test(navigator.userAgent) &&
    !get(isSafari15)
  ) {
    isSafari15.set(true);
  }
});

/**
 * Return the correct video source for a conversation video. If there
 * is a video response, use that, otherwise use a random static intro
 * video.
 *
 * @returns {string} src
 */
export const conversation = derived(
  [experience, response, viewport],
  ([$experience, $response]) => {
    if ($response && $response.payload && $response.payload.video) {
      return getVideoSourceWithParams({
        experience: $experience,
        video: $response.payload.video
      });
    }

    if (!$experience || typeof $experience.media !== "object") {
      return null;
    }

    const intros = $experience.media.intros;
    const params = "";

    if (
      typeof intros !== "object" ||
      (!Object.keys(intros).length && $experience.skipIntro)
    ) {
      return getVideoSourceWithParams({
        experience: $experience,
        params,
        video: shuffleVideos($experience.media.dwells)
      });
    }

    return getVideoSourceWithParams({
      experience: $experience,
      params,
      video: shuffleVideos(intros)
    });
  }
);

/**
 * Return the correct video source for a random dwell video.
 *
 * @returns {string} src
 */
export const dwell = derived([experience, viewport], ([$experience]) => {
  if (
    !$experience ||
    typeof $experience.media !== "object" ||
    typeof $experience.media.dwells !== "object" ||
    !Object.keys($experience.media.dwells).length
  ) {
    return null;
  }

  const params = "";

  return getVideoSourceWithParams({
    experience: $experience,
    params,
    video: shuffleVideos($experience.media.dwells)
  });
});
